import { createParser, system } from '../core';
import { t } from '../utils';
var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes('flexBasis'),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  flexDir: t.prop('flexDirection'),
  gap: t.space('gap')
};
export var flexbox = system(config);
export var flexboxParser = createParser(config);